import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import CustomTable from '@/components/admin/table';
const { Text } = Typography;

interface Review {
  id: string;
  firstName?: string;
  lastName?: string;
  [key: string]: any;
}

interface Props {
  reviews?: Review[];
  total: number;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
  setLimit: React.Dispatch<React.SetStateAction<number>>;
  downloadData?: (record: any) => void;
  downloadLoading?: boolean;
  columns: any[];
  handleModalOpen?: (booking: any, type: string) => void;
  customFilters?: React.ReactNode;
  label?: string;
}

const Reviews = ({
  reviews,
  total,
  page,
  setPage,
  limit,
  setLimit,
  downloadData,
  downloadLoading,
  columns,
  customFilters,
  label,
}: Props) => {
  const [filteredData, setFilteredData] = useState<Review[] | undefined>([]);

  useEffect(() => {
    if (!reviews) return;

    const formattedData = reviews.map((review) => {
      return review;
    });

    setFilteredData(formattedData);
  }, [reviews]);
  // if (!filteredData) return <Loader />;
  return (
    <>
      <div className="tables-info">
        <Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
          {total} Total Reviews
        </Text>
        <span className="tables-divider" />
        <Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
          Updated 20 min ago
        </Text>
      </div>
      <CustomTable
        data={reviews as any}
        columns={columns}
        filteredData={filteredData as any}
        setFilteredData={setFilteredData}
        label={label ?? 'Rating Management'}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        downloadData={downloadData}
        downloadLoading={downloadLoading}
        isReviewStatus
        customFilters={customFilters}
      />
    </>
  );
};

export default Reviews;
